import { http } from "./httpServices";
import api from "../apiConfig";
import { filterValidNews } from "../utils/newsUtils";
import { filterHiddenNews, hideNewsLocally } from "../utils/newsHiddenStorage";

// const url = api.local + "/news";
const url = api.global + "/news";

function sanitizeNewsId(id) {
  if (id == null || id === "") {
    throw new Error("Invalid news id");
  }

  const normalized = String(id).trim();
  if (
    !normalized ||
    normalized.includes("..") ||
    normalized.includes("/") ||
    normalized.includes("\\")
  ) {
    throw new Error("Invalid news id");
  }

  return normalized;
}

export function getNewsRecordId(newsOrId) {
  if (typeof newsOrId === "object" && newsOrId !== null) {
    return sanitizeNewsId(newsOrId._id || newsOrId.newsId);
  }

  return sanitizeNewsId(newsOrId);
}

function newsUrl(id) {
  return `${url}/${encodeURIComponent(getNewsRecordId(id))}`;
}

export function getAllNews() {
  return http.get(url);
}

export async function getAdminNews() {
  const response = await getAllNews();
  return {
    ...response,
    data: filterHiddenNews(response.data || []),
  };
}

export async function getPublicNews() {
  const response = await getAllNews();
  return {
    ...response,
    data: filterValidNews(response.data),
  };
}

export async function getNewsHeaders(){
  const news = await getPublicNews()
  return news.data
}

export async function deleteNews(newsOrId) {
  const id = getNewsRecordId(newsOrId);
  await http.delete(newsUrl(id));

  const response = await getAllNews();
  const stillExists = (response.data || []).some(
    (item) => item._id === id || item.newsId === id
  );

  if (stillExists) {
    const error = new Error(
      "The server reported success but this news item was not removed. The backend delete endpoint may be broken."
    );
    error.code = "DELETE_NOT_PERSISTED";
    error.newsItem = typeof newsOrId === "object" ? newsOrId : { _id: id };
    throw error;
  }
}

export async function hideNewsFromDashboard(newsOrId) {
  hideNewsLocally(typeof newsOrId === "object" ? newsOrId : { _id: newsOrId });
}

export async function getNews(newsId) {
  return http.get(newsUrl(newsId));
}

export function saveNews(news) {
  return http.post(url, news,
    {
      headers: {'Content-Type': 'multipart/form-data'}
    });
}

export function updateNews(news) {
  // console.log(news)
    return http.put(newsUrl(news._id), news,{
      headers: {'Content-Type': 'multipart/form-data'}
    });

}
